import React from 'react';
import PropTypes from 'prop-types';

import { Button, Input } from '../ui-components';
import Copyright from '../copyright/copyright';
import ModuleHeader from '../module-header/module-header';

import useWindowSize from '../../hooks/useWindowSize';
import { useLocalization } from '../../contexts/localization-context';
import { changeInputHandler, validateField } from '../../utils';
import {
  DESKTOP_WIDTH,
  EMAIL_REGEX,
  ErrorText,
  LoginText,
  Title,
} from '../../constants';

import './login.scss';

const Login = ({
  authData,
  handleForgotPasswordButtonClick,
  handleSignInButtonClick,
  isFormError,
  removeFormError,
  setAuthData,
}) => {
  const {
    userEmail,
    userEmailError,
    userEmailErrorMsg,
    userPassword,
    userPasswordError,
    userPasswordErrorMsg,
  } = authData;
  const windowSize = useWindowSize();
  const { getLocalization } = useLocalization();
  const loginTitle = windowSize.width < DESKTOP_WIDTH
    ? getLocalization(Title.MOBILE)
    : getLocalization(Title.DESKTOP);
  const loginText = windowSize.width < DESKTOP_WIDTH
    ? getLocalization(LoginText.MOBILE)
    : getLocalization(LoginText.DESKTOP);
  const emailLabel = getLocalization('E-mail address');
  const passwordLabel = getLocalization('Password');
  const forgotPasswordText = getLocalization('Forgot your password?');
  const signInText = getLocalization('Sign in');
  const failedAuthText = getLocalization(ErrorText.FAILED_AUTH);
  const emailErrorMsg = getLocalization(userEmailErrorMsg);
  const passwordErrorMsg = getLocalization(userPasswordErrorMsg);

  const checkFormFailure = () => !userEmail
    || userEmailError
    || !userPassword
    || userPasswordError
    || !EMAIL_REGEX.test(userEmail);

  return (
    <div className="login">
      <div className="login__wrapper">
        <ModuleHeader
          error={isFormError}
          text={isFormError ? failedAuthText : loginText}
          title={loginTitle}
        />
        <form className="login__form">
          <Input
            id="userEmail"
            errorMsg={emailErrorMsg}
            invalid={userEmailError}
            label={emailLabel}
            onBlur={(evt) => {
              validateField(
                evt,
                authData,
                setAuthData,
                (value) => EMAIL_REGEX.test(value),
                getLocalization(ErrorText.EMAIL_FORMAT_INVALID_ERROR),
                true,
              );
            }}
            onChange={(evt) => {
              changeInputHandler(evt, authData, setAuthData);
              removeFormError();
            }}
            value={userEmail}
          />
          <Input
            id="userPassword"
            errorMsg={passwordErrorMsg}
            invalid={userPasswordError}
            label={passwordLabel}
            onBlur={(evt) => {
              validateField(
                evt,
                authData,
                setAuthData,
                (value) => value.length > 0,
                '',
                true,
              );
            }}
            onChange={(evt) => {
              changeInputHandler(evt, authData, setAuthData);
              removeFormError();
            }}
            type="password"
            value={userPassword}
          />
          {typeof handleForgotPasswordButtonClick === 'function' && (
            <Button
              classNameCustom="login__reset"
              onClick={handleForgotPasswordButtonClick}
              text={forgotPasswordText}
            />
          )}
          <Button
            classNameCustom="login__submit-btn button_rectangle button_bg"
            disabled={checkFormFailure()}
            onClick={() => handleSignInButtonClick(userEmail, userPassword)}
            text={signInText}
          />
        </form>
      </div>
      <Copyright />
    </div>
  );
};

Login.defaultProps = {
  isFormError: false,
  handleForgotPasswordButtonClick: null,
  removeFormError: () => {},
};

Login.propTypes = {
  handleForgotPasswordButtonClick: PropTypes.func,
  handleSignInButtonClick: PropTypes.func.isRequired,
  isFormError: PropTypes.bool,
  removeFormError: PropTypes.func,
};

export default Login;
